var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgArrowForwardOrange = function SvgArrowForwardOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L10.187 10.6986C10.5494 11.0837 10.5494 11.6843 10.187 12.0694L2 20.768",
    stroke: "#FF6B00",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
};

export default __webpack_public_path__ + "static/media/arrow-forward-orange.93b3ae26.svg";
export { SvgArrowForwardOrange as ReactComponent };